import React, { Component } from 'react'
import { action } from 'mobx'
import { inject, observer } from 'mobx-react'
import { Select } from 'antd'
import { ControlSelect, Control } from '~/components/styles'

@inject('view')
@inject('data')
// @inject('userPoi')
@observer
class StationControl extends Component { 
  @action.bound
  handleStationChange (value, label) {
    const { view } = this.props
    // view.stationId = parseInt(value, 10)
    view.setStationIds(value ? [parseInt(value, 10)] : null)
  }
  // handleDeletePOIclick = (poiId) => action.bound((e) => {
  //   e.stopPropagation()
  //   const { view, userPoi } = this.props
  //   userPoi.deletePOI(poiId)
  //   view.setPoiId(null)
  // })
  // handleRenamePOI = (poiId) => action.bound((e) => {
  //   // console.log(e.target.value)
  //   // console.log(this.poiNameRef)
  //   const { userPoi } = this.props
  //   // console.log(poiId, e.target.value)
  //   userPoi.renamePOI(poiId, e.target.value)
  // })
  componentWillReceiveProps (nextProps) {
	const { view, data } = nextProps
    if (data.mainStationId && (!view.stationIds || !view.stationIds.length)) {
     this.handleStationChange([data.mainStationId])
    }
	
  }
  componentWillUpdate ({ view, data }) {
    if (data.mainStationId && (!view.stationIds || !view.stationIds.length)) {
      this.handleStationChange([data.mainStationId])
    }
  }
  
  constructor(props){
   super(props)
   this.handleStationChange([props.data.mainStationId])
}
  render () {
    const { view: { stationIds = [] }, title, data: { stations = [] } } = this.props
    const [stationId] = stationIds || []
	const selectedValue = stationId ? stationId : 21
//    const selectedValue = stationId
    return <Control>
      {title}
      <ControlSelect placeholder="เลือกลุ่มน้ำ" value={`${selectedValue}`} onChange={this.handleStationChange} dropdownMatchSelectWidth={false}>
        {stations.filter(station => station.isResponseData).map(station =>
          <Select.Option key={station.id} value={`${station.id}`}>
            {station.stationName}
          </Select.Option>
        )}
      </ControlSelect>
    </Control>
  }
}

export default StationControl



// WEBPACK FOOTER //
// ./src/modules/Monitoring/StationControl.js